import * as React from "react";
const SvgFiRrM = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-m_svg__a)">
      <path
        fill="#062147"
        d="M23 24a1 1 0 0 1-1-1V3.486c0-.86-.587-1.306-1.137-1.436-.548-.13-1.273.006-1.658.776l-6.311 12.621c-.339.678-1.45.678-1.789 0l-6.31-12.62c-.385-.77-1.109-.906-1.659-.776C2.587 2.181 2 2.626 2 3.487V23c-.006 1.308-1.995 1.307-2 0V3.486C0 1.841 1.076.482 2.677.104s3.171.357 3.907 1.828L12 12.764l5.416-10.832C18.151.46 19.723-.277 21.323.104 22.924.482 24 1.841 24 3.486V23a1 1 0 0 1-1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-m_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrM;
